// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609012323/js/" + chunkId + "." + {"44":"5cf232b3","225":"afa9624d","481":"828e6498","486":"9c769a64","770":"8b896b51"}[chunkId] + ".0.13825975929082157.chunk.js";
};